import React from 'react';
import PropTypes from 'prop-types';
import { get, isEmpty } from 'lodash';
import Table from '../../elements-table/table';
import moment from 'moment';
import { itemCategory } from './PayoutsUtils';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';

const PayoutItems = ({ payoutItems, intl }) => {
  return (
    <div className="payouts-items-table">
      <Table
        headerContainerClass="payouts-items-table-header"
        tableHeaders={
          [
            { label: <FormattedMessage id="hosting.payout_items.table_header_item" defaultMessage="Item"/>, classname: 'flex-basis-35-sm flex-basis-45' },
            { label: <FormattedMessage id="hosting.payout_items.table_header_booking_date" defaultMessage="Booking date"/>, classname: 'flex-basis-30 hidden-xs' },
            { label: <FormattedMessage id="hosting.payout_items.table_header_amount" defaultMessage="Amount"/>, classname: 'flex-basis-30-sm flex-basis-45 text-right' },
            { label: '', classname: 'flex-basis-5-sm flex-basis-10' }
          ]
        }
        tableBodyClass="payouts-table-body no-gutter"
        tableBody={
          payoutItems.map((item) => {
            const { guest = {} } = item;
            const firstName = get(guest, 'name.first', '');
            const lastName = get(guest, 'name.last', '');
            const bookingDate = get(item, 'booking.dts_start', '');
            const useType = get(item, 'listing.use_type', '');
            const displayAmount = get(item, 'amount.display_string', '');
            const category = get(itemCategory, [item.category], {});
            const isHostReferral = 'referral_commission' === item.category;
            const itemLabel = !isEmpty(category.text) ? (
              <FormattedMessage
                id='hosting.payout_items.label'
                defaultMessage="{category} for {firstName} {lastName}'s {useType}"
                values={{
                  category: intl.formatMessage(category.text),
                  firstName,
                  lastName,
                  useType: useType.toLowerCase().replace('-', '')
                }}
              />
            ) : (
              <span>
                {firstName} {lastName}'s{' '}
                {useType.toLowerCase().replace('-', '')}
              </span>
            );

            return (
              <div key={item._id} className="flex payout-items-row">
                <div className="flex-basis-35-sm flex-basis-45 ellipsis flex middle">
                  {/* @TODO remove this when design picks a damages icon */}
                  {category.icon !== 'damages' && (
                    <img
                      alt={intl.formatMessage(category.alt)} className="margin-md-right ico"
                      src={`/web-hosting/assets/images/${category.icon}.svg?v=rb`}
                    />
                  )}
                  { isHostReferral ? <span>{ itemLabel }</span> : <a href={`/inbox/${get(item, 'booking.id', '')}`}>{ itemLabel}</a> }
                </div>
                <div className="flex-basis-30 hidden-xs">
                  {bookingDate && moment(bookingDate).format('ll')}
                </div>
                <div className="flex-basis-30-sm flex-basis-45 text-right">
                  {displayAmount}
                </div>
                <div className="flex-basis-5 flex-basis-10-xs" />
              </div>
            );
          })
        }
      />
    </div>
  );
};

PayoutItems.propTypes = {
  payoutItems: PropTypes.array.isRequired,
  intl: intlShape
};

export default injectIntl(PayoutItems);
